export default "__VITE_ASSET___SXqYVEO__"